
import { Vue, Component } from "vue-property-decorator";
import { mdiClose, mdiPlus, mdiTrashCan } from "@mdi/js";
import editor from "@/components/common/inline-editor/editor";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";

/**
 * Список цен произвольной длины: подпись, цена, старая цена.
 * Хранится массивом в поле объекта (или в расширенных свойствах, если поле расширенное) —
 * отдельной таблицы под это не нужно. Пустые строки при сохранении отбрасываются.
 */
@Component({
  mixins: [editor],
})
export default class pricelist extends Vue {
  visible = false;
  rows: Array<{ caption: string; price: number | null; oldPrice: number | null }> = [];
  icons: any = {
    close: mdiClose,
    plus: mdiPlus,
    trash: mdiTrashCan,
  };
  private dataSource!: ObjectDataSource;
  private field!: any;
  $message: any;

  get summary(): string {
    const filled = this.rows.filter((r) => r.caption && r.price).length;
    return filled === 0 ? "..." : `строк: ${filled}`;
  }

  /** Значение поля: у расширенного свойства оно лежит в extendedProperties. */
  private get current(): any {
    const model: any = this.dataSource?.model;
    if (!model) return null;
    return this.field?.isExtended
      ? model.extendedProperties?.[this.field.name]
      : model[this.field.name];
  }

  close() {
    this.visible = false;
  }

  add() {
    this.rows.push({ caption: "", price: null, oldPrice: null });
  }

  remove(index: number) {
    this.rows.splice(index, 1);
  }

  async save() {
    const value = this.rows
      .filter((r) => (r.caption || "").trim() && r.price)
      .map((r) => ({
        caption: (r.caption || "").trim(),
        price: Number(r.price),
        oldPrice: r.oldPrice ? Number(r.oldPrice) : null,
      }));

    if (this.field?.isExtended) {
      const model: any = this.dataSource.model;
      if (!model.extendedProperties) model.extendedProperties = {};
      model.extendedProperties[this.field.name] = value;
      await this.dataSource.updateField({
        fieldName: "extendedProperties",
        fieldValue: model.extendedProperties,
      });
    } else {
      await this.dataSource.updateField({
        fieldName: this.field.name,
        fieldValue: value,
      });
    }

    this.$message("Поле успешно сохранено");
    this.visible = false;
  }

  created() {
    const value = this.current;
    // строку с JSON тоже принимаем: поле могли заполнить до появления этого редактора
    let parsed: any = value;
    if (typeof value === "string" && value.trim()) {
      try {
        parsed = JSON.parse(value);
      } catch {
        parsed = null;
      }
    }
    this.rows = Array.isArray(parsed)
      ? parsed.map((r: any) => ({
          caption: r?.caption ?? "",
          price: r?.price ?? null,
          oldPrice: r?.oldPrice ?? null,
        }))
      : [];
  }
}
